import React from 'react';
import { Condiment, Condiments } from '../../../models/condiment.entity';
import { apiManage_rbp } from '../../../request';
import GlobalNotification from '../../../component/common/snackbar';
import i18n from '../../../i18n';
import _ from 'lodash';
import Card from '../Card';
import CommonInput from '../../../component/form/common-input.component';
import { Box } from '@mui/material';
import Table from '../../../component/table/table';
import CondimentDetail from './condiment-detail.component';
import ButtonComponent from '../../../component/button/button.component';
import DeleteDialogComponent from '../../../component/dialog/delete-dialog.component';


/**
 * 调味品组详情组件
 */
class CondimentGroupDetail extends React.Component<Props, State> {
    public state: State = {
        // 详情
        detail: _.cloneDeep(this.props.detail) || {},
        // 删除确认框
        deleteOpen: false,
        // 删除的数据
        deleteDishIds: [],
        // 表格每页行数
        rowsPerPage: 20,
        // 当前页
        currPage: 0,
        // 当前选中的菜品item
        rowsSelected: []
    }
    // *********************
    // Life Cycle Function
    // *********************
    constructor(props: Props) {
        super(props);
        this.getMenuData = this.getMenuData.bind(this);
        this.onSave = _.debounce(this.onSave, 500, {
            leading: true,
            trailing: false
        }).bind(this) as any;
    }
    // *********************
    // Default Function
    // *********************

    /**
     * 保存
     */
    async onSave() {
        const { detail } = this.state;
        // 名字不能为空
        if (_.trim(detail.comdiment_groups_name)) {
            // setLinearLoading(true);
            // 需要修改的字段
            const params = {
                id: detail.scomdiment_groups_id as number,
                comdiment_groups_name: detail.comdiment_groups_name as string
            }
            const result = await apiManage_rbp.patch_condiment_group(params);
            // 修改成功
            if (!_.get(result, 'error') && result.affectedRows > 0) {
                // 刷新数据
                this.props.updateMenuData();
                GlobalNotification.success(i18n.t('global_text_operate_success'));
            }
            else {
                GlobalNotification.error(i18n.t('global_text_operate_failure'));
            }
            // setLinearLoading(false);
        }
    }

    /**
     * 新增菜品
     */
    addMenuDish() {
        this.setState({
            menuDishData: {
                // 所在菜单id
                scomdiment_groups_id: this.props.detail?.scomdiment_groups_id
            }
        })
    }


    /**
     * 批量删除菜品
     */
    async handleDeleteDishes() {
        // setLinearLoading(true);
        const { deleteDishIds } = this.state;
        // 请求接口
        const result = await apiManage_rbp.del_condiment(deleteDishIds)
        // 修改成功
        if (!_.get(result, 'error')) {
            // 刷新数据
            await this.props.updateMenuData();
            GlobalNotification.success(i18n.t('global_text_operate_success'));
            // 清除勾选状态
            this.setState({
                rowsSelected: []
            })
        }
        else {
            GlobalNotification.error(i18n.t('global_text_operate_failure'));
        }
        // setLinearLoading(false);
    }

    /**
     * 刷新数据
     */
    async getMenuData() {
        await this.props.updateMenuData(this.state.detail.scomdiment_groups_id);
    }

    /**
     * 选中项，表格头部工具栏显示
     * @returns
     */
    public handleTableToolbarSelectRender(
        selectedRows: { data: Array<{ index: number; dataIndex: number }>; lookup: { [key: number]: boolean } }
    ): React.ReactNode {
        // 选中的数据
        const dishSelected = selectedRows.data.map((item) => (_.get(this.props.detail, `comdiments[${item.dataIndex}].item_id`, 0)));
        return (
            <Box padding={'4px 12px'}>
                <ButtonComponent
                    action='DELETE'
                    handleClick={() => {
                        this.setState({
                            deleteOpen: true,
                            deleteDishIds: dishSelected
                        })
                    }}
                />
            </Box>
        )
    }

    // *********************
    // View
    // *********************

    render() {
        const { majorGroupList, familyGroupList, unitList } = this.props;
        const { detail, menuDishData, deleteOpen, rowsPerPage } = this.state;
        const columns = [
            {
                name: 'item_id',
                label: i18n.t('google_text_id'),
            },
            {
                name: 'item_name1',
                label: i18n.t('global_text_name'),
            },
            {
                name: 'price_1',
                label: i18n.t('menu_and_dishes_page_price'),
                options: {
                    searchable: false
                }
            },
            {
                name: 'unit_1',
                label: i18n.t('menu_and_dishes_page_specification'),
                options: {
                    searchable: false
                }
            },
            {
                name: 'major_group',
                label: i18n.t('condiment_page_custom_form_main_type'),
                options: {
                    customBodyRenderLite: (dataIndex: number) => {
                        const curData = majorGroupList.find((item) => item.value === this.props.detail.comdiments?.[dataIndex]?.major_group)
                        return curData?.label || ''
                    },
                    searchable: false
                }
            },
            {
                name: 'family_group',
                label: i18n.t('condiment_page_custom_form_sub_type'),
                options: {
                    customBodyRenderLite: (dataIndex: number) => {
                        const curData = familyGroupList.find((item) => item.value === this.props.detail.comdiments?.[dataIndex]?.family_group)
                        return curData?.label || ''
                    },
                    searchable: false
                }
            },
            {
                name: 'action',
                label: i18n.t('google_text_check_detail'),
                options: {
                    sort: false,
                    download: false,
                    searchable: false,
                    customBodyRenderLite: (dataIndex: number) => {
                        return (
                            <ButtonComponent
                                action='VIEW'
                                handleClick={() => {
                                    // 当前菜品详情数据
                                    const currentMenuDishData = _.get(this.props.detail, `comdiments[${dataIndex}]`);
                                    this.setState({
                                        menuDishData: currentMenuDishData,
                                    })
                                }}
                            />
                        )
                    }
                }
            }
        ]
        return (
            <div>
                <Card
                    title={i18n.t('menu_and_dishes_page_basic_info')}
                    actionRender={(
                        <ButtonComponent
                            action='SAVE'
                            handleClick={() => { this.onSave() }}
                        />
                    )}
                    contentRender={(
                        <CommonInput
                            variant={'outlined'}
                            fullWidth
                            label={i18n.t('global_text_name')}
                            required={true}
                            regularType='required'
                            value={detail.comdiment_groups_name || ''}
                            onChange={(event) => {
                                const value = event.currentTarget.value
                                const setDetail = _.set(detail, 'comdiment_groups_name', value)
                                this.setState({
                                    detail: setDetail,
                                })
                            }} />
                    )}
                />
                <Box marginTop='10px'>
                    {
                        menuDishData ?
                            <Box paddingTop='8px'>
                                <CondimentDetail
                                    detail={menuDishData}
                                    handleClickBack={() => {
                                        this.setState({
                                            menuDishData: undefined,
                                        })
                                    }}
                                    getMenuData={async () => await this.getMenuData()}
                                    taxGroup={this.props.taxGroup}
                                    lastId={this.props.lastId}
                                    familyGroupList={familyGroupList}
                                    majorGroupList={majorGroupList}
                                    unitList={unitList}
                                />
                            </Box>
                            :
                            <>
                                <ButtonComponent
                                    action='ADD'
                                    sx={{ marginBottom: 2 }}
                                    handleClick={() => { this.addMenuDish() }}
                                />
                                <Table
                                    data={this.props.detail.comdiments || []}
                                    columns={columns}
                                    rowsSelected={this.state.rowsSelected}
                                    onRowSelectionChange={(currentRowsSelected: any[], allRowsSelected: any[], rowsSelected?: any[]) => {
                                        this.setState({
                                            rowsSelected: rowsSelected || []
                                        })
                                    }}
                                    otherOption={{

                                        viewColumns: true,
                                        download: true,
                                        downloadOptions: {
                                            filename: this.props.detail.comdiment_groups_name,

                                        },
                                        search: true,
                                        pagination: true,
                                        rowsPerPage,
                                        page: this.state.currPage,
                                        onChangePage: (page: number) => {
                                            this.setState({ currPage: page })
                                        },
                                        onChangeRowsPerPage: (nums: number) => {
                                            this.setState({
                                                rowsPerPage: nums,
                                            })
                                        },
                                        customToolbarSelect: (
                                            selectedRows,
                                        ): React.ReactNode => {
                                            return this.handleTableToolbarSelectRender(selectedRows);
                                        },
                                        selectableRowsHeader: true,
                                        selectableRowsHideCheckboxes: false,
                                        selectToolbarPlacement: 'replace',
                                        // onRowsDelete: (rowsDeleted, newTableData) => {
                                        //     this.setState({
                                        //         deleteOpen: true,
                                        //         deleteDishIds: rowsDeleted.data.map((item) => (
                                        //             _.get(this.props.detail, `comdiments[${item.dataIndex}].item_id`, 0)
                                        //         ))
                                        //     })
                                        // },
                                    }}
                                />
                            </>
                    }


                </Box>
                {
                    deleteOpen &&
                    <DeleteDialogComponent
                        {...{
                            title: i18n.t('condiment_page_delete_condiment'),
                            open: true,
                            onCancel: () => {
                                this.setState({
                                    deleteOpen: false
                                })
                            },
                            onConfirm: async () => {
                                await this.handleDeleteDishes()
                                this.setState({
                                    deleteOpen: false
                                })
                            },
                        }}
                    />
                }
            </div>

        )
    }
}

export default CondimentGroupDetail;

// *********************
// Type
// *********************
type Props = {
    // 详情
    detail: Condiments;
    // 更新数据
    updateMenuData: (id?: number) => Promise<Condiments>;
    // 税率组列表
    taxGroup: { label: string; value: number; }[];
    // 最大的id
    lastId: number;
    // 自定义报表主类别
    majorGroupList: { label: string; value: number; }[];
    // 自定义报表子类别
    familyGroupList: { label: string; value: number; }[];
    // 规格设置
    unitList: { label: string; value: string; }[];
}
type State = {
    // 详情
    detail: Condiments
    // 当前菜品详情
    menuDishData?: Condiment;
    // 删除确认框
    deleteOpen: boolean;
    // 当前选中的要删除的项目
    deleteDishIds: number[];
    // 表格每页行数
    rowsPerPage: number;
    // 当前页
    currPage: number;
    // 当前选中的菜品item
    rowsSelected: any[]
}